import axios from 'axios'
import store from '../store'
import router from '../router'

const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  timeout: 5000
});

const APP_ID = process.env.VUE_APP_APPID
const API_KEY = process.env.VUE_APP_APIKEY

service.interceptors.request.use(config => {
  const headers = config.headers || {};
  if (store.state.token) {
    headers['access-token'] = store.state.token;
  }
  headers['appid'] = APP_ID;
  headers['apikey'] = API_KEY;
  config.headers = headers;
  return config;
});

service.interceptors.response.use(response => {
  const res = response.data;
  if (res.code === 1) {
    return res.data;
  } else {
    if (res.code === 401) {
      store.commit('clearToken')
      router.push('/login')
    }
    return Promise.reject(res.message || 'Error');
  }
}, error => {
  if (error.response && error.response.status === 401) {
    store.commit('clearToken')
    router.push('/login')
  }
  return Promise.reject(error);
});

export default service;
